import { ExternalLink, Trash2 } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Cards({category, title, createdAt, id, handleDelete}) {
    const navigate = useNavigate();
    return (
        <div  className="bg-base-100 rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden">
            <div className="p-6">
                <div className="flex justify-between items-start">
                    <div>
                        <h3 className="text-2xl font-bold text-base-content" style={{textTransform:"capitalize"}}>{category}</h3>
                        <h3 className="mt-2 text-lg font-semibold text-base-content" style={{textTransform:"capitalize"}}>{title}</h3>
                    </div>
                </div>
                
                <div className="flex justify-between items-center mt-5">
                    <span className="text-xs text-base-content/60">Created {createdAt.split("T")[0].split("-").reverse().join("-")}</span>
                </div>
                
                <div className="flex justify-between items-center mt-4 pt-4 border-t border-base-200">
                    <button className="btn btn-sm btn-error btn-outline gap-1" onClick={() => handleDelete(id)}>
                        <Trash2 size={16} />
                        <span>Delete</span>
                    </button>
                    
                    <div className="flex gap-2">
                        <button className="btn btn-sm btn-outline gap-1 btn-info" onClick={() => navigate(`/roadmap/${id}`)}>
                            <ExternalLink size={16} />
                            <span>Open</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}